import styles from "./googleSigninButton.module.scss";
import GoogleIcon from "@icons/googleIcon.svg";

export function GoogleSigninButton(props: Props) {
  const { label, className, ...rest } = props;
  return (
    <button
      className={styles["googleButton"]}
      data-testid="select-google-method"
      {...rest}
    >
      <GoogleIcon />
      {label}
    </button>
  );
}

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
}
